import { TODO, UIBModal } from '@b2b/types/core';
import angular, { IScope } from 'angular';

ProgramsCombosRemoveModalController.$inject = ['$scope', '$uibModalInstance', 'currentCombo'];

function ProgramsCombosRemoveModalController(
  $scope: IScope & {
    cancel: TODO;
    done: TODO;
    errors: TODO;
    hasErrors: TODO;
    init: TODO;
    model: TODO;
    success: TODO;
  },
  $uibModalInstance: UIBModal<TODO>,
  currentCombo: TODO
) {
  $scope.errors = [];

  $scope.model = {};

  $scope.init = function () {
    this.model = currentCombo;
  };

  $scope.hasErrors = function () {
    return $scope.errors.length > 0;
  };

  $scope.done = function () {
    $scope.success();
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.success = function () {
    $uibModalInstance.close(true);
  };

  $scope.init();
}

export const ProgramsCombosRemoveModalControllerModule = angular
  .module('acme.view.application.programs.combos.removeModal.controllers', [])
  .controller('ProgramsCombosRemoveModalController', ProgramsCombosRemoveModalController).name;
